import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96898874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card module-bar" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "module-bar__name" }
const _hoisted_4 = { class: "module-bar__progress" }
const _hoisted_5 = { class: "module-bar__progress-label" }
const _hoisted_6 = { class: "lp-bar" }
const _hoisted_7 = { class: "module-bar__actions" }

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { FALLBACK_IMAGE, useCourseI18n } from '../course';


export default /*#__PURE__*/_defineComponent({
  props: {
    module: null,
    moduleNumber: null,
    modulesTotal: null,
    lessonsDone: null,
    lessonsTotal: null
  },
  emits: ["share"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'share'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  module: any
  moduleNumber: number | null
  modulesTotal: number
  lessonsDone: number
  lessonsTotal: number
}





const { t, lang, tc } = useCourseI18n();

const percent = computed(() => props.lessonsTotal ? Math.round((props.lessonsDone / props.lessonsTotal) * 100) : 0);
const canShare = computed(() => props.module.module_status === 'completed' && props.module.course?.has_achievement);
const courseRoute = computed(() => ({ name: 'training-module-list', params: { id: props.module.course?.id } }));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _unref(courseRoute),
      class: "module-bar__thumb"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: __props.module.image_url || __props.module.course?.image_url || _unref(FALLBACK_IMAGE),
          alt: __props.module.title
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("small", null, [
        (__props.moduleNumber)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(tc)('module_of', { current: __props.moduleNumber, total: __props.modulesTotal })) + " · ", 1)
            ], 64))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(__props.module.course?.name), 1)
      ]),
      _createElementVNode("strong", null, _toDisplayString(__props.module.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_unref(tc)('lessons_watched_of', { done: __props.lessonsDone, total: __props.lessonsTotal })), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(percent)) + "%", 1)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _createElementVNode("span", {
          style: _normalizeStyle({ width: `${_unref(percent)}%` })
        }, null, 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_unref(canShare))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "lp-btn lp-btn--sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('share')))
          }, [
            _createVNode(HcIcon, {
              name: "linkedin",
              size: 15
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(lang)}.common.share_on_linkedin`)), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: _unref(courseRoute),
        class: "lp-btn lp-btn--sm lp-btn--outline"
      }, {
        default: _withCtx(() => [
          _createVNode(HcIcon, {
            name: "chevron-left",
            size: 15
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(lang)}.common.back_to_course`)), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})